import { render, staticRenderFns } from "./room.vue?vue&type=template&id=c9a143ce&scoped=true"
import script from "./room.vue?vue&type=script&lang=js"
export * from "./room.vue?vue&type=script&lang=js"
import style0 from "./room.vue?vue&type=style&index=0&id=c9a143ce&prod&lang=css"
import style1 from "./room.vue?vue&type=style&index=1&id=c9a143ce&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9a143ce",
  null
  
)

export default component.exports